import React, { Component } from 'react';
import { change, Field, reduxForm } from 'redux-form';
import Select2 from 'react-select2-wrapper';
import { browserHistory, Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withPreference from '../../common/withPreference';
import Header from '../../components/Header';
import {
  renderField,
  required,
  preferenceNameExtraMatches
} from '../../helpers/form-validations';
import {
  countImplantInstrument,
  isMobile,
  onGoBack,
  sortData
} from '../../common/globals';
import {
  getCaseType,
  getPreferenceByName
} from '../../utils/db';
import withOnline from '../../common/withOnline';
import {
  removePreference,
  editPreference,
  addPreference
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import PreferenceDeleteConfirmation from '../../components/Models/PreferenceDeleteConfirmation';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import withSetsListStateStorage from '../../common/withSetsListStateStorage';

class AddPreference extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preference: {
        id: '',
        PreferenceName: '',
        RepNotes: '',
        Comments: '',
        CaseType: '',
        selectedSets: []
      },
      caseTypes: [],
      instrumentCount: 0,
      implantCount: 0
    };
    this.deletePreference = null;
    this.savePreferenceOnBack = null;
  }

  componentDidMount() {
    try {
      const { setSetsListStateStorage } = this.props;
      setSetsListStateStorage({});
      this.deletePreference = new window.bootstrap.Modal(
        window.$('#preferenceDeleteConfirmation')
      );
      this.savePreferenceOnBack = new window.bootstrap.Modal(
        window.$('#acmProductGoBackModal')
      );
      window.scrollTo(0, 0);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = () => {
    try {
      const {
        notify, preference, setLoader, online, setPreference
      } = this.props;
      preference.PreferenceName = preference.PreferenceName.toUpperCase();

      if (!online) {
        notify({ type: 'error', message: 'You must have an internet connection. Please check you connection and try again.', time: 3 });
        return false;
      }

      let APICall = null;
      setLoader(true);
      if (preference.id !== '') {
        APICall = editPreference(preference.id, preference);
      } else {
        APICall = addPreference(preference);
      }

      APICall.then((response) => {
        const { result, message } = response;
        setLoader(false);
        if (result === 'success') {
          // notify({ type: 'success', message });
          setPreference({});
          browserHistory.push('/preferences');
        } else {
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddSets = () => {
    try {
      const {
        goBack, setGoBack, preference, notify
      } = this.props;
      if (preference.CaseType === '') {
        notify({ type: 'error', message: 'Please select case type.' });
        return;
      }

      goBack.push(window.location.pathname);
      setGoBack(goBack);
      browserHistory.push((preference.id !== '') ? `/preferences/${preference.id}/sets` : '/preferences/new/sets');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseType = async () => {
    try {
      const typeRes = await getCaseType();
      const sortType = sortData(typeRes, 'OptionName');
      this.setState({
        caseTypes: sortType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fetchPreference = () => {
    try {
      const {
        params, preference
      } = this.props;
      const id = params.hasOwnProperty('id') ? params.id : '';
      this.setState({
        preference: { ...preference, id },
      }, () => {
        this._fillForm();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fillForm = () => {
    try {
      const { dispatch } = this.props;
      const { preference } = this.state;
      Object.keys(preference).map((key) => {
        dispatch(change('preferenceForm', key, preference[key]));
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemovePreference = async () => {
    try {
      const {
        preference, setPreference, online, setLoader, notify
      } = this.props;
      if (online) {
        setLoader(true);
        await removePreference(preference.id).then(async (response) => {
          setLoader(false);
          const { result, message } = response;
          if (result === 'success') {
            // notify({ type: 'success', message });
            setPreference({});
            browserHistory.push('/preferences');
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.'
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveCancelOrBack = () => {
    try {
      const {
        setPreference, goBack
      } = this.props;
      setPreference({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = async () => {
    try {
      const { preference } = this.props;
      if (preference.id !== '') {
        const oldPreference = await getPreferenceByName(preference.id);
        if (oldPreference.length > 0) {
          if (oldPreference[0].PreferenceName !== preference.PreferenceName
            || oldPreference[0].CaseType !== preference.CaseType
            || oldPreference[0].RepNotes !== preference.RepNotes
            || oldPreference[0].Comments !== preference.Comments) {
            // TODO: Compare selectedSets as well
            this.savePreferenceOnBack.show();
          } else {
            this._onSaveCancelOrBack();
          }
        } else {
          this._onSaveCancelOrBack();
        }
      } else if (preference.PreferenceName !== '' || preference.CaseType !== '') {
        this.savePreferenceOnBack.show();
      } else {
        this._onSaveCancelOrBack();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPreferenceSave = () => {
    try {
      const {
        notify, preference
      } = this.props;

      if (Object.keys(preference).length > 0) {
        if (preference.PreferenceName === '') {
          notify({ type: 'error', message: 'Please enter preference name.' });
          return;
        }

        if (preference.CaseType === '') {
          notify({ type: 'error', message: 'Please select case type.' });
          return;
        }

        if (preference.selectedSets.length === 0) {
          notify({ type: 'error', message: 'Please select sets.' });
          return;
        }
        this._onSubmit();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangePreferenceName = (e) => {
    try {
      const { preference } = this.state;
      this.setState({ preference: { ...preference, PreferenceName: e.target.value } }, () => {
        this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeRepNotes = (key, value) => {
    try {
      const { preference } = this.state;
      // window.firstLetterCapital('#preferenceRepNotes');
      preference[key] = value;
      this.setState({
        preference: {
          ...preference,
        }
      }, () => {
        this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  onChangeComments = (key, value) => {
    try {
      const { preference } = this.state;
      preference[key] = value;
      // window.firstLetterCapital('#preferenceOfficeNotes');
      this.setState({
        preference: {
          ...preference,
        }
      }, () => {
        this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeCaseType = (e) => {
    try {
      const { preference } = this.state;
      this.setState({ preference: { ...preference, CaseType: e.target.value } }, () => {
        this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _updatePreferenceState = () => {
    try {
      const { setPreference } = this.props;
      const { preference } = this.state;
      setPreference(preference);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const { preference } = this.props;
      this._getCaseType();
      this._fetchPreference();
      // Count implant/instrument
      const qtyImplantInstrument = countImplantInstrument(preference.selectedSets);
      this.setState({
        instrumentCount: qtyImplantInstrument.instrumentQty,
        implantCount: qtyImplantInstrument.implantQty
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  render() {
    const {
      handleSubmit,
      params
    } = this.props;
    const {
      preference,
      caseTypes,
      instrumentCount,
      implantCount
    } = this.state;
    return (
      <section className="list-section">
        <form onSubmit={handleSubmit(this._onPreferenceSave)} form="preferenceForm">
          <Header
            actionButton={(preference.id !== '') ? { title: 'Save' } : { title: 'Add' }}
            actionButtonExtra={(preference.id !== '') ? {
              title: <i className="fas fa-trash" />,
              type: 'button',
              onClick: () => {
                this.deletePreference.show();
              }
            } : ''}
            title={(preference.id !== '') ? 'Edit Preference' : 'Add Preference'}
            goBack={this._onGoBack}
          />
          <section className="case-details-section pb-5 mb-4">
            <div className="container">
              <div className="row gx-2">
                <div className="col-12 col-md-4">
                  <div className="case-data">
                    <label htmlFor="PreferenceName">Preference Name</label>
                    <Field
                      type="text"
                      name="PreferenceName"
                      className="form-control text-uppercase"
                      placeholder="Name"
                      component={renderField}
                      validate={[required, preferenceNameExtraMatches]}
                      onChange={this._onChangePreferenceName}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="case-data">
                    <label htmlFor="type">Case Type</label>
                    <Select2
                      id="single"
                      className="form-control"
                      style={{ width: '100%' }}
                      data={caseTypes.map((value) => (value.OptionName))}
                      onSelect={this._onChangeCaseType}
                      value={preference.CaseType}
                      options={{ placeholder: 'Select Case Type' }}
                      disabled={params.hasOwnProperty('id')}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="case-data">
                    <label htmlFor="RepNotes">Rep Notes (not seen by office)</label>
                    <p className={`${isMobile ? '' : 'uc-first-letter'}`}>
                      <Field
                        type="textarea"
                        name="RepNotes"
                        id="preferenceRepNotes"
                        className="form-control"
                        defaultValue={preference.RepNotes}
                        placeholder="Add Notes"
                        component={renderField}
                        // onChange={this._onChangeRepNotes}
                        onChange={(event) => this._onChangeRepNotes('RepNotes', window.UCFirst(event.target.value))}
                      />
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="case-data">
                    <label htmlFor="Comments">Office Notes</label>
                    <p className={`${isMobile ? '' : 'uc-first-letter'}`}>
                      <Field
                        type="textarea"
                        name="Comments"
                        id="preferenceOfficeNotes"
                        defaultValue={preference.Comments}
                        className="form-control"
                        placeholder="Add Notes"
                        component={renderField}
                        // onChange={this.onChangeComments}
                        onChange={(event) => this.onChangeComments('Comments', window.UCFirst(event.target.value))}
                      />
                    </p>
                  </div>
                </div>

              </div>
              <hr />
              <div className="top-block">
                <div className="row">
                  <div className="col">
                    <h4>Sets</h4>
                  </div>
                  <div className="col-auto">
                    <div className="case-data">
                      <label htmlFor="implants">Implants: {implantCount}</label>
                      <label htmlFor="instruments" className="ps-3">Instruments: {instrumentCount}</label>
                    </div>
                  </div>
                  <div className="col-12 pt-2">
                    <button type="button" className="btn btn-theme-alt btn-theme-outline-alt w-100" onClick={this._onAddSets}>Add Sets</button>
                  </div>
                </div>
              </div>

              <div className="sets-list-blocks preferences-add t-b-border-0">
                <div className="sets-block">
                  {
                    preference.selectedSets.map((item, index) => (
                      <ul className="list-unstyled" key={index}>
                        <li>
                          <Link
                            className="over-link"
                          >&nbsp;
                          </Link>
                          <div className="left-side">
                            <span className="count">{item.Quantity}</span>
                          </div>
                          <div className="right-side">
                            <p>{item.SetName}</p>
                          </div>
                        </li>
                      </ul>
                    ))
                  }
                </div>
              </div>

            </div>
          </section>
        </form>
        <PreferenceDeleteConfirmation
          onRemovePreference={this._onRemovePreference}
        />
        <ACMProductGoBackModal
          onSave={this._onPreferenceSave}
          onCancel={this._onSaveCancelOrBack}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'preferenceForm',
});

export default withPreference(
  withOnline(
    withForm(
      withGoBack(
        withNotify(
          withLoader(
            withSetsListStateStorage(
              AddPreference
            )
          )
        )
      )
    )
  )
);
